import Header from './Header';
import Footer from './Footer';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import WOW from 'wowjs';
import 'animate.css';
function LocationList() {
  const [europe, setEurope] = useState([]);
  const [northamerica, setNorthAmerica] = useState([]);
  const [middleeast, setMiddleEast] = useState([]);
  const [oceania, setOceania] = useState([]);
  const [africa, setAfrica] = useState([]);
  const [asia, setAsia] = useState([]);

  const [activitydatas, setActivityDatas] = useState(null);

  // Helper function
  const getData = (url, setter) => {
    fetch(url)
      .then(res => res.json())
      .then(res => setter(res.data || []))
      .catch(err => console.log(err));
  };

  useEffect(() => {
    getData("https://planjourneysglobal.com/admin/api/locations/byCategory/europe", setEurope);
    getData("https://planjourneysglobal.com/admin/api/locations/byCategory/north_america", setNorthAmerica);
    getData("https://planjourneysglobal.com/admin/api/locations/byCategory/middle_east", setMiddleEast);
    getData("https://planjourneysglobal.com/admin/api/locations/byCategory/oceania", setOceania);
    getData("https://planjourneysglobal.com/admin/api/locations/byCategory/africa", setAfrica);
    getData("https://planjourneysglobal.com/admin/api/locations/byCategory/asia", setAsia);
  }, []);

  useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/home_page/banners/destination")
      .then(res => res.json())
      .then(res => setActivityDatas(res.data?.[0] || null))
      .catch(err => console.log(err));
  }, []);
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false,
      offset: 0,
      mobile: true,
    });
    wow.init();
  }, []);
  return (
    <>
    <Helmet>
  <title>
    {activitydatas?.meta_title || "Top Travel Destinations | Plan Journeys Global"}
  </title>

  <meta
    name="description"
    content={
      activitydatas?.meta_discription ||
      "Explore top travel destinations worldwide with Plan Journeys Global. Discover international and domestic trips."
    }
  />

  <meta
    name="keywords"
    content={
      activitydatas?.meta_keyword ||
      "travel destinations, holiday destinations, international travel, tour packages"
    }
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content={activitydatas?.meta_title || "Travel Destinations"}
  />
  <meta
    property="og:description"
    content={
      activitydatas?.meta_discription ||
      "Explore top destinations worldwide with Plan Journeys Global."
    }
  />

  {/* Optional image */}
  {activitydatas?.image_url && (
    <meta property="og:image" content={activitydatas.image_url} />
  )}

  <meta property="og:type" content="website" />

  {/* Twitter */}
  <meta
    name="twitter:title"
    content={activitydatas?.meta_title || "Travel Destinations"}
  />
  <meta
    name="twitter:description"
    content={
      activitydatas?.meta_discription ||
      "Discover amazing travel destinations worldwide."
    }
  />

  {activitydatas?.image_url && (
    <meta name="twitter:image" content={activitydatas.image_url} />
  )}

  <meta name="twitter:card" content="summary_large_image" />
</Helmet>
      <Header />

      {/* Breadcrumb section */}
      <div
        className="breadcrumb-section"
        style={{
          backgroundImage: activitydatas?.image_url
            ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${activitydatas.image_url})`
            : "none"
        }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{activitydatas?.banner_name}</h1>
          </div>
        </div>
      </div>
       {activitydatas?.short_discription?.trim() && (
  <div className="container">
    <div
      className="row justify-content-center mb-50 mt-30 wow animate fadeInDown"
      data-wow-delay="200ms"
      data-wow-duration="1500ms"
    >
      <div className="col-lg-6">
        <div className="section-title text-center">
          <div
            dangerouslySetInnerHTML={{
              __html: activitydatas.short_discription
            }}
          />
        </div>
      </div>
    </div>
  </div>
)}



      {/* Destination Page */}
      <div className="destination-page pt-100 mb-100 mt-50">
        <div className="container">
          <div className="row gy-md-5 gy-4">

            {/* Europe */}
            <DestinationCard
              title="Europe"
              bgImage="assets/img/innerpages/destination-card4-img1.jpg"
              list={europe}
            />

            {/* Asia */}
            <DestinationCard
              title="Asia"
              bgImage="assets/img/innerpages/destination-card4-img2.jpg"
              list={asia}
            />

            {/* Africa */}
            <DestinationCard
              title="Africa"
              bgImage="assets/img/innerpages/destination-card4-img3.jpg"
              list={africa}
            />

            {/* Oceania */}
            <DestinationCard
              title="Oceania"
              bgImage="assets/img/innerpages/destination-card4-img4.jpg"
              list={oceania}
            />

            {/* Middle East */}
            <DestinationCard
              title="Middle East"
              bgImage="assets/img/innerpages/destination-card4-img5.jpg"
              list={middleeast}
            />

            {/* North America */}
            <DestinationCard
              title="North America"
              bgImage="assets/img/innerpages/destination-card4-img6.jpg"
              list={northamerica}
            />

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

// Reusable card component
function DestinationCard({ title, bgImage, list }) {
  return (
    <div
      className="col-lg-6 wow animate fadeInDown"
      data-wow-delay="500ms"
      data-wow-duration="3000ms"
    >
      <div className="destination-card4">
        <div
          className="destination-img-wrap"
          style={{
            backgroundImage:
              `linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0.25) 100%), url(${bgImage})`
          }}
        >
          <div className="destination-title-area">
            <h2>{title}</h2>
          </div>
        </div>

        <div className="destination-wrapper newsblock">
          <ul className="destination-list">
            {list.map((item, i) => (
              <li key={i}>
                <Link to={`/destination/${item.slug}`}>
                     <img
        src={`https://planjourneysglobal.com/admin/${item.location_icon}`}
        alt={item.name}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/assets/img/no-image.png";
        }}
      />
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
}

export default LocationList;
